import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ETAPaymentMethod } from '~/api/ETA';
import { ETADeliveryMethodType } from '~/api/ETADeliveryMethodType';
import { Checkbox } from '~/components/Checkbox';
import { deliveryAddressStore } from '~/components/ModalDeliveryAddress/DeliveryAddressStore';

import { cartStore, checkoutStore } from '~/stores';

import styles from './DeliveryInstructions.module.scss';

type Props = {
  classNames?: string;
};

const DeliveryInstructions = ({ classNames }: Props) => {
  const { t } = useTranslation();
  const [instructionList, setInstructionList] = useState<string[]>([]);

  const handleToggleInstruction = (val: string) => {
    if (deliveryAddressStore.editAddressData?.instructions.includes(val)) {
      deliveryAddressStore.deleteInstruction(val);
    } else {
      deliveryAddressStore.addInstruction(val);
    }
  };

  useEffect(() => {
    const list =
      (t('deliveryInstructionsList', { returnObjects: true }) as string[]) ||
      [];
    if (list.length && cartStore.isAdultItemInCart) {
      list.shift();
    }
    setInstructionList(list);
  }, [t]);

  useEffect(() => {
    if (
      checkoutStore.activePaymentMethod !== ETAPaymentMethod.Cash ||
      instructionList.length < 3
    ) {
      return;
    }

    if (checkoutStore.instructionList[0]) {
      // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
      handleToggleInstruction(instructionList[0], 0);
    }
  }, [checkoutStore.activePaymentMethod]);

  if (checkoutStore.deliveryMethod === ETADeliveryMethodType.ClickAndCollect) {
    return <></>;
  }

  return (
    <div className={classes([styles.instructions, classNames])}>
      {instructionList.map((el) => {
        // const attributeName = el
        //   .toLocaleLowerCase()
        //   .replace(`'`, '')
        //   .split(' ')
        //   .join('-');

        return (
          <Checkbox
            className={styles.checkbox}
            labelClassName={styles.label}
            key={el}
            label={el}
            value={''}
            onChange={() => handleToggleInstruction(el)}
            checked={deliveryAddressStore.editAddressData.instructions.includes(
              el,
            )}
          />
          // <label
          //   className={classes([styles.instructionContainer])}
          //   key={el}
          //   htmlFor={attributeName}
          // >
          //   <input
          //     id={attributeName}
          //     data-checkbox={attributeName}
          //     type="checkbox"
          //     className={styles.instruction}
          //     onChange={() => handleToggleInstruction(el)}
          //     checked={deliveryAddressStore.editAddressData.instructions.includes(
          //       el,
          //     )}
          //   />
          //   <span className={styles.instructionMark} />
          //   {el}
          // </label>
        );
      })}
    </div>
  );
};

export default observer(DeliveryInstructions);
